import React from 'react';
import { InstagramIcon, FacebookIcon } from 'lucide-react';
import { Logo } from './Logo';
import { useLanguage } from '../contexts/LanguageContext';
import { LINKS } from '../data/translations';
function TikTokIcon({
  size = 22
}: {
  size?: number;
}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" data-id="element-56" data-mp="32m1bozwzl2p5">
      <path d="M16.5 3h-2.7v11.4a2.4 2.4 0 1 1-1.9-2.35V9.3a5.1 5.1 0 1 0 4.6 5.07V8.9a5.6 5.6 0 0 0 3.4 1.16V7.35A3.5 3.5 0 0 1 16.5 3Z" data-id="element-57" data-mp="3ueil1vox90cx" />
    </svg>;
}
export function Footer() {
  const {
    t
  } = useLanguage();
  const socials = [{
    label: 'Instagram',
    href: LINKS.instagram,
    icon: InstagramIcon
  }, {
    label: 'TikTok',
    href: LINKS.tiktok,
    icon: TikTokIcon
  }, {
    label: 'Facebook',
    href: LINKS.facebook,
    icon: FacebookIcon
  }];
  return <footer className="w-full border-t border-slate-200 bg-white" data-id="element-58" data-mp="29xvtajtenpsh">
      <div className="mx-auto w-full max-w-[1280px] px-5 py-12 sm:px-8" data-id="element-59" data-mp="2ezb99xgq7640">
        <div className="flex flex-col gap-8 md:flex-row md:items-center md:justify-between" data-id="element-60" data-mp="3l90lhpgqmmw3">
          <div className="max-w-[520px]" data-id="element-61" data-mp="3gapcti26iifg">
            <Logo data-id="element-62" data-mp="3gc0g7grppo61" />
            <p className="mt-4 text-[15px] leading-relaxed text-slate-500" data-id="element-63" data-mp="3gcjzp1x0gkm6">
              {t.footer.description}
            </p>
          </div>

          <ul className="flex items-center gap-5" aria-label={t.footer.followUs} data-id="element-64" data-mp="3q83pr7ow8p30">
            {socials.map(social => <li key={social.label} data-id="element-65" data-mp="80xmugrj9fnb">
                <a href={social.href} target="_blank" rel="noreferrer" aria-label={social.label} className="inline-flex h-11 w-11 items-center justify-center rounded-full text-blue-600 transition-colors hover:bg-blue-50 hover:text-blue-700" data-id="element-66" data-mp="34gt971ke92u">
                  <social.icon size={24} data-id="element-67" data-mp="qtrsgk39nvev" />
                </a>
              </li>)}
          </ul>
        </div>

        <div className="mt-10 flex flex-col items-center gap-5 border-t border-slate-200 pt-8 md:flex-row md:justify-between" data-id="element-68" data-mp="tv4mo01f303y">
          <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3" aria-label="Footer navigation" data-id="element-69" data-mp="ytei8br202q3">
            {t.footer.links.map(link => <a key={link} href="#" className="text-[15px] text-slate-500 transition-colors hover:text-slate-900" data-id="element-70" data-mp="18k943f0e10b0">
                {link}
              </a>)}
          </nav>
          <p className="text-[14px] text-slate-400" data-id="element-71" data-mp="1hms6xz46bcx9">{t.footer.rights}</p>
        </div>
      </div>
    </footer>;
}